export default __webpack_public_path__ + "static/media/next_icon.4309f819.svg";